(function () {
  'use strict';
  if (customElements.get('sticky-image-cards')) return;
  class StickyImageCards extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.container = this.closest('[data-section-type="sticky-image-cards"]');
      this.body = this.querySelector('[data-sticky-card-body]');
      this.wrapper = [...this.querySelectorAll('[data-sticky-card-wrapper]')];
      this.aside = this.querySelector('[data-sticky-card-aside]');
      this.media = [...this.querySelectorAll('[data-sticky-card-media]')];
      this.textInContent = [...this.querySelectorAll('[data-sticky-card-content] [data-sticky-card-text]')];
      if (!this.container || !this.body || !this.media.length || !this.wrapper.length) return;
      this.onScrollCallback = () => this.schedule(false);
      this.onResizeCallback = () => this.schedule(true);
      document.addEventListener('theme:scroll', this.onScrollCallback);
      document.addEventListener('theme:resize', this.onResizeCallback);
      window.visualViewport?.addEventListener('resize', this.onResizeCallback);
      this.media.forEach(node => node.querySelectorAll('img').forEach(img => img.addEventListener('load', this.onResizeCallback)));
      this.needsMeasure = true;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting);
          if (this.inView) this.schedule(true);
        }, {rootMargin: '450px 0px'});
        this.observer.observe(this.container);
      } else { this.inView = true; this.schedule(true); }
    }
    schedule(measure) {
      this.needsMeasure = this.needsMeasure || measure;
      if (!this.inView || this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0; if (!this.isConnected || !this.inView) return;
        if (this.needsMeasure) { this.needsMeasure = false; this.calculateHeights(); }
        else this.detectStickyPositions();
      });
    }
    calculateHeights() {
      this.isDesktop = window.theme.getWindowWidth() >= window.theme.sizes.large;
      this.isMobile = window.theme.isMobile();
      this.headerHeight = window.theme.readHeights().stickyHeaderHeight || 0;
      this.spacingTop = parseInt(getComputedStyle(this.container).getPropertyValue('--padding'),10) || 20;
      this.wrapperTop = this.isMobile ? this.spacingTop : parseInt(getComputedStyle(this.wrapper[0]).top,10) || 0;
      this.stickyTop = this.isMobile ? this.spacingTop : Math.floor(this.wrapperTop - this.headerHeight);
      this.wrapper.forEach(node => { node.style.setProperty('--item-height','auto'); node.style.setProperty('--item-double-height','auto'); node.style.setProperty('--row-height','auto'); });
      this.textInContent.forEach(node => node.style.setProperty('--row-height','auto'));
      this.frame = requestAnimationFrame(() => {
        this.frame = 0; if (!this.isConnected) return;
        const rows = this.isDesktop ? this.textInContent.map((node,i) => Math.max(node.offsetHeight,this.media[i]?.offsetHeight || 0)) : [];
        rows.forEach((height,i) => { this.textInContent[i].style.setProperty('--row-height',height+'px'); this.wrapper[i]?.style.setProperty('--row-height',height+'px'); });
        this.frame = requestAnimationFrame(() => {
          this.frame = 0; if (!this.isConnected) return;
          this.heights = this.wrapper.map(node => node.offsetHeight);
          let total = 0; this.cumulativeHeights = this.heights.map(height => { const before = total; total += height; return before; });
          this.updateSpillover(); this.detectStickyPositions();
        });
      });
    }
    detectStickyPositions() {
      if (!this.cumulativeHeights) return;
      const top = Math.round(this.body.getBoundingClientRect().top - this.headerHeight - this.wrapperTop);
      const positions = this.wrapper.map(node => Math.floor(node.getBoundingClientRect().top - this.headerHeight));
      this.wrapper.forEach((node,i) => {
        if (this.isMobile) {
          if (i < this.wrapper.length-1) node.classList.toggle('has-passed-sticky',positions[i+1] <= this.stickyTop);
          this.container.classList.toggle('checkpoint-'+(i+1),top <= -this.cumulativeHeights[i]);
        }
        node.classList.toggle('is-stuck-up',positions[i] <= this.stickyTop);
      });
    }
    updateSpillover() {
      if (!this.isMobile) return;
      const available = (window.visualViewport?.height || window.innerHeight) - this.headerHeight - this.wrapperTop;
      this.wrapper.forEach((node,i) => {
        const height = this.heights[i], spills = height > available;
        node.classList.toggle('spillover',spills);
        node.style.setProperty('--item-height',spills ? height+'px' : 'auto');
        node.style.setProperty('--item-double-height',spills ? height*2+'px' : 'auto');
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect(); cancelAnimationFrame(this.frame);
      document.removeEventListener('theme:scroll',this.onScrollCallback); document.removeEventListener('theme:resize',this.onResizeCallback);
      window.visualViewport?.removeEventListener('resize',this.onResizeCallback);
      this.media?.forEach(node => node.querySelectorAll('img').forEach(img => img.removeEventListener('load',this.onResizeCallback)));
      this.ready = false;
    }
  }
  customElements.define('sticky-image-cards',StickyImageCards);
})();
